import { AirTimeRegistrationImpl } from "features/airTimeRegistration/data/AirTimeRegistrationImpl";
import { AirTimeRegistrationViewModel } from "features/airTimeRegistration/presentation/viewModel/AirTimeRegistrationViewModel";
import { IAirTimeRegistrationRepository } from "../domain/repositories/IAirTimeRegistrationRepository";
import { AirTimeRegistrationUseCase } from "../domain/useCases/AirTimeRegistrationUseCase";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class AirTimeRegistrationInjection extends InjectionModule {
  private static readonly airTimeRegistrationRepositoryToken = Symbol(
    "IAirTimeRegistrationRepository",
  );
  private static readonly airTimeRegistrationViewModelToken = Symbol(
    "AirTimeRegistrationViewModel",
  );
  private static readonly airTimeRegistrationUseCaseToken = Symbol(
    "AirTimeRegistrationUseCase",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.airTimeRegistrationRepositoryToken,
      useClass: AirTimeRegistrationImpl,
    },
    {
      scope: "otherRepo",
      token: this.airTimeRegistrationUseCaseToken,
      useClass: AirTimeRegistrationUseCase,
    },
    {
      scope: "viewModel",
      token: this.airTimeRegistrationViewModelToken,
      useClass: AirTimeRegistrationViewModel,
    },
  ];

  static getAirTimeRegistrationRepo(): IAirTimeRegistrationRepository {
    return this.resolve(this.airTimeRegistrationRepositoryToken);
  }

  static getAirTimeRegistrationUseCase(): AirTimeRegistrationUseCase {
    return this.resolve(this.airTimeRegistrationUseCaseToken);
  }
}
